import { Badge, Button } from '@/shared/ui';
import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import { usePaymentSettingsListViewModel } from '../hooks/use-payment-settings-list-view-model.hook';

/** Configurações > Produtos > Formas de pagamento: a lista de produtos. */
export function PaymentSettingsList() {
  const { rows, isLoading, error, refetch, catalogSourceLabel } =
    usePaymentSettingsListViewModel();

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between'>
        <div className='min-w-0'>
          <h2 className='text-lg font-semibold text-alba-black-500'>
            Formas de pagamento
          </h2>
          <p className='mt-1 text-sm text-alba-gray-600'>
            As formas que o corretor oferece em cada produto e como o Portal
            cobra o segurado.
          </p>
        </div>
        {catalogSourceLabel && (
          <Badge tone='blue'>Catálogo: {catalogSourceLabel}</Badge>
        )}
      </div>

      {isLoading && (
        <p className='py-8 text-center text-sm text-alba-gray-500'>
          Carregando...
        </p>
      )}

      {error && (
        <div className='flex flex-col items-center gap-3 py-8 text-sm text-alba-error-red-600'>
          <p>{error}</p>
          <Button
            type='button'
            variant='outline'
            size='md'
            onClick={() => void refetch()}
          >
            Tentar novamente
          </Button>
        </div>
      )}

      {rows.length > 0 && (
        <ul className='divide-y divide-alba-gray-200 overflow-hidden rounded-xl border border-alba-gray-200 bg-white'>
          {rows.map(row => (
            <li
              key={row.productCode}
              className='flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between'
            >
              <div className='flex min-w-0 flex-col gap-2'>
                <p className='font-medium text-alba-black-500'>
                  {row.name}{' '}
                  <span className='text-sm font-normal text-alba-gray-500'>
                    · {row.productCode}
                  </span>
                </p>
                <div className='flex flex-wrap gap-2'>
                  <Badge tone={row.status.tone}>{row.status.label}</Badge>
                  {row.methods.map(method => (
                    <Badge key={method} tone='gray'>
                      {method}
                    </Badge>
                  ))}
                </div>
                <p className='text-xs text-alba-gray-600'>
                  {[row.catalogSummary, row.inheritsNote]
                    .filter(Boolean)
                    .join(' · ')}
                </p>
                {row.updatedNote && (
                  <p className='text-xs text-alba-gray-500'>
                    {row.updatedNote}
                  </p>
                )}
              </div>
              {row.actionLabel && (
                <Link
                  to='/settings/products/payment-methods/$productCode'
                  params={{ productCode: row.productCode }}
                  className='flex shrink-0 items-center gap-1 self-start rounded-xl px-3 py-2 text-sm font-medium text-alba-blue-500 hover:bg-alba-gray-200 sm:self-center'
                >
                  {row.actionLabel}
                  <ChevronRight aria-hidden='true' className='h-4 w-4' />
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
